export default {
  intranetHost: 'hl.lcp.jdl.com',
  gatewayOuterBaseApi: 'https://intl-holland-api.jingdonglogistics.com/',
  gatewayBaseApi: 'http://intl-holland-lop.jingdonglogistics.com/',
  gatewayFileBaseApi: 'http://intl-holland-lop.jingdonglogistics.com/',
  domainErp: '//ssa.jd.com',
  gatewayApiDecoupling: 'http://intl-holland-lop.jingdonglogistics.com',
  jingMeAuthAlias: 'lop-holland-intl'
}
